import { memo } from 'react'

import { SVGProps } from './types/iconType'

export const CopyIcon = memo(({ className, style }: SVGProps) => {
  return (
    <svg className={className} style={style} viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.5 8.828a1.578 1.578 0 0 0-.072-.324v-.108a1.284 1.284 0 0 0-.227-.336L15.035.86A1.278 1.278 0 0 0 14.7.632a.38.38 0 0 0-.107 0A1.048 1.048 0 0 0 14.199.5H9.36a3.592 3.592 0 0 0-3.583 3.6v1.2H4.583A3.592 3.592 0 0 0 1 8.9v12c0 1.988 1.604 3.6 3.583 3.6h9.556a3.592 3.592 0 0 0 3.583-3.6v-1.2h1.195a3.592 3.592 0 0 0 3.583-3.6V8.828zm-7.167-4.236L18.427 7.7h-1.9c-.659 0-1.194-.537-1.194-1.2V4.592zm0 16.308c0 .663-.534 1.2-1.194 1.2H4.583c-.66 0-1.194-.537-1.194-1.2v-12c0-.663.535-1.2 1.194-1.2h1.195v8.4c0 1.988 1.604 3.6 3.583 3.6h5.972v1.2zm4.778-4.8c0 .663-.535 1.2-1.194 1.2H9.36c-.66 0-1.194-.537-1.194-1.2v-12c0-.663.534-1.2 1.194-1.2h3.583v3.6c0 1.988 1.605 3.6 3.584 3.6h3.583v6z"
        fillRule="evenodd"
      />
    </svg>
  )
})
